import create from 'zustand'

const useStore = create(set => ({
    title: 'The 5th at Charisma',
    pageIndex: 0,
    changePage: (index) => set({ pageIndex: index })
}))

export default useStore